import { fromJS } from 'immutable';
import {
  SET_EXPERT_EXPERTISE_MISSIONS,
  RESET_STORE_EXPERTISE,
} from 'containers/ExpertAssignedMissions/constants';
import { SET_EXPERTISE_MISSION } from 'containers/ExpertAssignedMissionShow/constants';

const initialState = fromJS({
  expertExpertiseMissions: [],
  expertiseMission: null,
});

const expertExpertiseMissionsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_EXPERT_EXPERTISE_MISSIONS:
      return state.set('expertExpertiseMissions', fromJS(action.payload));
    case SET_EXPERTISE_MISSION:
      return state.set('expertiseMission', fromJS(action.payload[0]));
    case RESET_STORE_EXPERTISE:
      return initialState;
    default:
      return state;
  }
};

export default expertExpertiseMissionsReducer;
